<!-- 增加了动态绑定disabled功能 -->
<template>
  <h2>11</h2>
</template>

<script>
export default {
  //科室表单下拉列表
  name: 'FormEmptySelect',
  data () {
    return {
      options: [],
      selectValue: this.value
    }
  },
  props: {
    value: {
    },
    // 增加了动态绑定disabled功能
    disabled:{
      
    }
  },
  methods: {
    change: function () {
      this.$emit('input', this.selectValue)
    }
  },
  watch: {
    value (newVal) {
      this.selectValue = newVal
    }
  },
  mounted: function () {

  }
}
</script>

<style>
</style>
